export default {
  sizes: ["Bit", "KB", "MB", "GB", "TB", "PB"],
  uploadNoMoreFiles: "Upload no more than {maxFileCount} files",
  maxFileSize: {
    upppercase: "Up to {maxFileSize}",
    lowercase: "up to {maxFileSize}",
  },
  maxUploadFilesAmountWithSize:
    "up to {maxFilesAmount} files up to {maxFileSize} each",
  minMaxUploadFilesAmountWithSize:
    "from {from} to {to} files no more than {size} each",
  oneUploadFileWithMaxsize: "1 file up to {maxFileSize}",
  newFileAction: {
    moveOr: "Drag and drop or",
    upload: "upload files",
  },
  validation: {
    maxSize: "Maximum file size exceeded",
    unsupportedFileType: "Unsupported file format",
    addedUnsupportedFiles: "Unsupported files were added",
    totalSizeNotMoreThan: "Total file size should not exceed {totalSize}",
    exceedFilesAmountLimit: "File upload quantity limit exceeded",
  },
  uploadPhoto: "Upload photo",
  photoAspect: "Image aspect ratio — {aspect}",
  pictureEditing: "Image editing",
  selectedAreaWillDisplay:
    "The selected area will be displayed when viewing your establishment in RC PAY.",
};
